// extracted by mini-css-extract-plugin
export default {"signUpPage":"SignUp_signUpPage__rm8gX"};